export interface CompanySettings {
    company_id: string
    settings: {
        [key: string]: SettingSection
    }
    audit: AuditInfo
    version: number
}

export interface SettingSection {
    data: {
        [key: string]: any
    }
    encrypted_fields?: string[]
}

export interface AuditInfo {
    created_at: string
    created_by: string
    updated_at: string
    updated_by: string
    change_log?: Change[]
}

export interface Change {
    timestamp: string
    user: string
    action: string
    section?: string
}

// Setting categories
export const CATEGORY_GENERAL = "general"
export const CATEGORY_SECURITY = "security"
export const CATEGORY_FEATURES = "features"
export const CATEGORY_MOBILE_BANKING = "mobile_banking"
export const CATEGORY_DIAGNOSTICS = "diagnostics"

// Category display names
export const CATEGORY_NAMES: { [key: string]: string } = {
    // [CATEGORY_GENERAL]: "General",
    [CATEGORY_SECURITY]: "Security",
    // [CATEGORY_FEATURES]: "Features",
    [CATEGORY_MOBILE_BANKING]: "Mobile Banking",
    [CATEGORY_DIAGNOSTICS]: "Diagnostics"
}

// Field display names
export const FIELD_NAMES: { [key: string]: { [key: string]: string } } = {
    [CATEGORY_GENERAL]: {
        company_name: "Company Name",
        timezone: "Timezone",
        date_format: "Date Format",
        currency: "Currency",
        language: "Language"
    },
    [CATEGORY_SECURITY]: {
        allow_user_deletion: "Allow Unregistering Users",
        show_account_balances: "Show Account Balances"
    },
    [CATEGORY_FEATURES]: {
        enable_transfers: "Enable Transfers",
        enable_bill_payment: "Enable Bill Payment",
        enable_mobile_deposit: "Enable Mobile Deposit",
        maintenance_mode: "Maintenance Mode"
    },
    [CATEGORY_MOBILE_BANKING]: {
        host_url: "Host URL",
        timeout_seconds: "Timeout (seconds)",
    }
}

export interface ValidationRequest {
    section: string
    settings: {
        [key: string]: any
    }
}

export interface ValidationResponse {
    valid: boolean
    errors?: {
        [key: string]: string
    }
}